import { Reducer } from "redux";

import { IctAutocompleteState } from "../models/api/Patient";
import { IcdCodeDispatchTypes } from "../models/dispatchTypes/Patient";
import { IcdCodeActionDispatchTypes } from "../constants/Patient";

const defaultIcdObject = [
  {
    icdDiagnosisCodeId: 0,
    icdCode: "",
    icdDescription: "",
    clinicalGroupId: 0,
    clinicalGroupDescription: "",
  },
];

export const initialIcdState: IctAutocompleteState = {
  loading: false,
  field1: defaultIcdObject,
  field2: defaultIcdObject,
  field3: defaultIcdObject,
  field4: defaultIcdObject,
  error: null,
};

const IcdCodeReducer: Reducer<IctAutocompleteState, IcdCodeDispatchTypes> = (
  state = initialIcdState,
  action
) => {
  switch (action.type) {
    case IcdCodeActionDispatchTypes.ICD_CODE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case IcdCodeActionDispatchTypes.ICD_CODE_SUCCESS: {
      return {
        ...state,
        loading: false,
        [action.field]: action.response,
      };
    }
    case IcdCodeActionDispatchTypes.ICD_CODE_RESET: {
      if (action.field === "all") {
        return initialIcdState;
      }
      return {
        ...state,
        [action.field]: [],
      };
    }
    case IcdCodeActionDispatchTypes.ICD_CODE_ERROR: {
      return initialIcdState;
    }
  }
  return state;
};

export default IcdCodeReducer;
